// Test astral Ritual (v2) — flujo: preguntas → datos de nacimiento → email →
// teaser (signo solar gratis, Luna/ASC bloqueados) → paywall → Stripe Payment Link.
// Config: window.RF_CFG { variantId, precioTexto, stripeUrl, locale } (sections/rf-quiz.liquid).
// Datos: window.RF_QUIZ (assets/rf-preguntas.js).
// i18n: textos por idioma en I18N (es = base; en/fr/de). Preguntas, opciones, nombres de signo y de
// país se traducen por posición/código sobre RF_QUIZ, sin modificar rf-preguntas.js (lo comparte la
// calculadora). Sin traducción para un dato, cae al español. Eventos, claves de storage, ids y
// valores enviados a endpoints NO se traducen.
(function () {
  var cont = document.getElementById("rf-quiz");
  if (!cont) return;
  var barra = document.getElementById("rf-barra");
  var QUIZ = window.RF_QUIZ;
  var CFG = window.RF_CFG || {};
  var TOTAL_PASOS = QUIZ.preguntas.length + 2; // + nacimiento + email
  var idx = 0;
  var codigo = { enfoque: "p", momento: "4", nivel: "a" };
  var nac = null; // {fecha, hora|null, ciudad, cc}

  var MESES_EN = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  var I18N = {
    es: {
      qNum: function (n, total) { return "Tu momento · Pregunta " + n + " de " + total; },
      nacTitulo: "Los datos de tu carta",
      nacIntro: "Tu carta natal se calcula con el cielo EXACTO del momento en que naciste:",
      fecha: "Fecha de nacimiento",
      hora: "Hora de nacimiento",
      sinHora: "No sé mi hora exacta (tu carta se calcula igual)",
      pais: "País donde naciste",
      ciudad: "Ciudad donde naciste",
      ciudadPh: "Ej. Guadalajara",
      calcular: "Calcular mi carta",
      errNac: "Completa tu fecha y ciudad de nacimiento.",
      emailTitulo: "Tu carta está calculándose",
      emailIntro: function (f, ciudad) {
        return "Posiciones planetarias del " + f.split("-").reverse().join("/") + " sobre " + ciudad + ". ¿Para quién es esta carta?";
      },
      nombrePh: "Tu nombre",
      emailPh: "tu@correo.com",
      ver: "Ver mi resultado gratis",
      errEmail: "Escribe un correo válido.",
      emailNota: "Recibirás tu resultado y contenido astral. Sin spam, date de baja cuando quieras.",
      notaHora: "Sin hora exacta tu carta se calcula en modo solar (sin Ascendente ni casas) — igual de válida para todo lo demás.",
      tuSol: "Tu Sol está en",
      energia: function (n, d) { return "Energía " + n + ": " + d + "."; },
      solUno: 'Pero tu Sol es solo <strong>1 de los 12 puntos</strong> de tu carta. Ya calculamos los otros 11 con el cielo exacto de tu nacimiento:',
      luna: "🔒 Tu <strong>Luna</strong> (tu mundo emocional real)<br>",
      asc: "🔒 Tu <strong>Ascendente</strong> (cómo te ve el mundo)<br>",
      venusMarte: "🔒 <strong>Venus y Marte</strong> (cómo amas y deseas)<br>",
      medioCielo: "🔒 Tu <strong>Medio Cielo</strong> (vocación y dinero)<br>",
      aspectos: "🔒 Los <strong>aspectos</strong> entre tus planetas (tus patrones)",
      cartaCompleta: "Tu Carta Natal completa",
      li1: "<strong>Rueda natal calculada</strong> con efemérides suizas — precisión de software profesional",
      li2: "Posiciones exactas de tus 10 planetas, en signos y casas",
      li3: "Tus tres grandes integrados: Sol, Luna y Ascendente",
      li4: "Amor, carrera y dinero según TU carta (no tu signo)",
      li5: function (e) { return "<strong>Capítulo especial</strong> sobre lo que elegiste: tu " + e; },
      li6: "Informe de 15+ páginas en PDF, a tu correo en menos de 1 hora",
      precioNota: "Pago único. Sin suscripción, sin cargos recurrentes.",
      comprar: "Quiero mi carta completa",
      errPago: "No pudimos iniciar el pago. Intenta de nuevo.",
      garantia: "🛡️ Garantía de 7 días: si no te aporta, te devolvemos el 100%.",
      aviso: "Contenido de entretenimiento y autoconocimiento.",
      preparando: "Preparando tu pago…",
      enfoque: { a: "vida amorosa", c: "carrera y dinero", p: "propósito de vida", e: "mundo emocional" },
      preguntas: null, // null = usa las de rf-preguntas.js (es)
      signos: null,
      paises: null
    },
    en: {
      qNum: function (n, total) { return "Your moment · Question " + n + " of " + total; },
      nacTitulo: "Your chart details",
      nacIntro: "Your natal chart is calculated with the EXACT sky of the moment you were born:",
      fecha: "Date of birth",
      hora: "Time of birth",
      sinHora: "I don't know my exact time (your chart is calculated anyway)",
      pais: "Country where you were born",
      ciudad: "City where you were born",
      ciudadPh: "e.g. Guadalajara",
      calcular: "Calculate my chart",
      errNac: "Enter your date and city of birth.",
      emailTitulo: "Your chart is being calculated",
      emailIntro: function (f, ciudad) {
        var p = f.split("-");
        return "Planetary positions for " + parseInt(p[2], 10) + " " + MESES_EN[parseInt(p[1], 10) - 1] + " " + p[0] + " over " + ciudad + ". Who is this chart for?";
      },
      nombrePh: "Your name",
      emailPh: "you@email.com",
      ver: "See my free result",
      errEmail: "Enter a valid email address.",
      emailNota: "You'll receive your result and astrology content. No spam, unsubscribe whenever you want.",
      notaHora: "Without an exact time your chart is calculated in solar mode (no Ascendant or houses) — just as valid for everything else.",
      tuSol: "Your Sun is in",
      energia: function (n, d) { return n + " energy: " + d + "."; },
      solUno: 'But your Sun is only <strong>1 of the 12 points</strong> of your chart. We\'ve already calculated the other 11 with the exact sky of your birth:',
      luna: "🔒 Your <strong>Moon</strong> (your real emotional world)<br>",
      asc: "🔒 Your <strong>Ascendant</strong> (how the world sees you)<br>",
      venusMarte: "🔒 <strong>Venus and Mars</strong> (how you love and desire)<br>",
      medioCielo: "🔒 Your <strong>Midheaven</strong> (vocation and money)<br>",
      aspectos: "🔒 The <strong>aspects</strong> between your planets (your patterns)",
      cartaCompleta: "Your complete Natal Chart",
      li1: "<strong>Calculated natal wheel</strong> with Swiss ephemeris — professional software precision",
      li2: "Exact positions of your 10 planets, in signs and houses",
      li3: "Your integrated big three: Sun, Moon and Ascendant",
      li4: "Love, career and money according to YOUR chart (not your sign)",
      li5: function (e) { return "<strong>Special chapter</strong> on what you chose: your " + e; },
      li6: "15+ page PDF report, delivered to your inbox in under 1 hour",
      precioNota: "One-time payment. No subscription, no recurring charges.",
      comprar: "I want my complete chart",
      errPago: "We couldn't start the payment. Please try again.",
      garantia: "🛡️ 7-day guarantee: if it doesn't add anything for you, we refund 100%.",
      aviso: "Entertainment and self-knowledge content.",
      preparando: "Preparing your payment…",
      enfoque: { a: "love life", c: "career and money", p: "life purpose", e: "emotional world" },
      preguntas: [
        { t: "Which area of your life do you want your chart to illuminate first?", o: ["Love and my relationships", "My career and money", "My life purpose", "My energy and my emotions"] },
        { t: "How would you describe your current moment?", o: ["I'm starting a new cycle", "I feel stuck, something has to change", "I have an important decision ahead of me", "I'm looking for clarity, to know myself better"] },
        { t: "Which phrase do you identify with most?", o: ["\"I feel there's something more for me that I haven't found\"", "\"I repeat patterns and I don't know where they come from\"", "\"People don't really know me\"", "\"I'm in the right place, I want to confirm it\""] },
        { t: "When you make important decisions, what weighs the most?", o: ["My intuition — my body talks to me", "Logic — I analyze everything", "What I feel for others", "It depends on the day (and that confuses me)"] },
        { t: "How much do you know about astrology?", o: ["Nothing, it would be my first chart", "I know my sign", "I know my Sun, Moon and Ascendant", "Quite a lot — I want a serious reading"] }
      ],
      signos: [
        ["Capricorn", "a patient builder, more sensitive than you show"],
        ["Aquarius", "a free mind: you see what others don't see yet"],
        ["Pisces", "deep intuition — you feel the tide before anyone else"],
        ["Aries", "fire that starts things: where others hesitate, you've already begun"],
        ["Taurus", "presence and constancy: you build things that last"],
        ["Gemini", "infinite curiosity — your mind never gets bored"],
        ["Cancer", "deep emotional memory: you care like no one else"],
        ["Leo", "a heart that radiates: you were born to be seen"],
        ["Virgo", "a precise eye: you improve everything you touch"],
        ["Libra", "you seek harmony and the right balance in things"],
        ["Scorpio", "transformative intensity: nothing halfway"],
        ["Sagittarius", "an arrow to the horizon: you need meaning, not routine"]
      ],
      paises: { MX: "Mexico", US: "United States", CO: "Colombia", GT: "Guatemala", AR: "Argentina", ES: "Spain", PE: "Peru", CL: "Chile", EC: "Ecuador", VE: "Venezuela", BO: "Bolivia", HN: "Honduras", SV: "El Salvador", NI: "Nicaragua", CR: "Costa Rica", PA: "Panama", DO: "Dominican Republic", PY: "Paraguay", UY: "Uruguay", PR: "Puerto Rico", OTRO: "Other country" }
    },
    fr: {
      qNum: function (n, total) { return "Ton moment · Question " + n + " sur " + total; },
      nacTitulo: "Les données de ta carte",
      nacIntro: "Ta carte du ciel est calculée avec le ciel EXACT du moment de ta naissance :",
      fecha: "Date de naissance",
      hora: "Heure de naissance",
      sinHora: "Je ne connais pas mon heure exacte (ta carte est calculée quand même)",
      pais: "Pays de naissance",
      ciudad: "Ville de naissance",
      ciudadPh: "Ex. Guadalajara",
      calcular: "Calculer ma carte",
      errNac: "Indique ta date et ta ville de naissance.",
      emailTitulo: "Ta carte est en cours de calcul",
      emailIntro: function (f, ciudad) {
        return "Positions planétaires du " + f.split("-").reverse().join("/") + " au-dessus de " + ciudad + ". Pour qui est cette carte ?";
      },
      nombrePh: "Ton prénom",
      emailPh: "toi@email.com",
      ver: "Voir mon résultat gratuit",
      errEmail: "Saisis une adresse e-mail valide.",
      emailNota: "Tu recevras ton résultat et du contenu astral. Pas de spam, désinscris-toi quand tu veux.",
      notaHora: "Sans l'heure exacte, ta carte est calculée en mode solaire (sans Ascendant ni maisons) — tout aussi valable pour le reste.",
      tuSol: "Ton Soleil est en",
      energia: function (n, d) { return "Énergie " + n + " : " + d + "."; },
      solUno: "Mais ton Soleil n'est que <strong>1 des 12 points</strong> de ta carte. Nous avons déjà calculé les 11 autres avec le ciel exact de ta naissance :",
      luna: "🔒 Ta <strong>Lune</strong> (ton vrai monde émotionnel)<br>",
      asc: "🔒 Ton <strong>Ascendant</strong> (comment le monde te voit)<br>",
      venusMarte: "🔒 <strong>Vénus et Mars</strong> (comment tu aimes et désires)<br>",
      medioCielo: "🔒 Ton <strong>Milieu du Ciel</strong> (vocation et argent)<br>",
      aspectos: "🔒 Les <strong>aspects</strong> entre tes planètes (tes schémas)",
      cartaCompleta: "Ta carte du ciel complète",
      li1: "<strong>Roue natale calculée</strong> avec les éphémérides suisses — précision d'un logiciel professionnel",
      li2: "Positions exactes de tes 10 planètes, en signes et maisons",
      li3: "Ton big three intégré : Soleil, Lune et Ascendant",
      li4: "Amour, carrière et argent selon TA carte (pas ton signe)",
      li5: function (e) { return "<strong>Chapitre spécial</strong> sur ce que tu as choisi : " + e; },
      li6: "Rapport PDF de 15+ pages, dans ta boîte mail en moins d'une heure",
      precioNota: "Paiement unique. Sans abonnement, sans frais récurrents.",
      comprar: "Je veux ma carte du ciel complète",
      errPago: "Nous n'avons pas pu lancer le paiement. Réessaie.",
      garantia: "🛡️ Garantie de 7 jours : si ça ne t'apporte rien, on te rembourse 100 %.",
      aviso: "Contenu de divertissement et de connaissance de soi.",
      preparando: "Préparation de ton paiement…",
      enfoque: { a: "ta vie amoureuse", c: "ta carrière et ton argent", p: "ton objectif de vie", e: "ton monde émotionnel" },
      preguntas: [
        { t: "Quel domaine de ta vie veux-tu que ta carte éclaire en premier ?", o: ["L'amour et mes relations", "Ma carrière et l'argent", "Mon objectif de vie", "Mon énergie et mes émotions"] },
        { t: "Comment décrirais-tu ton moment actuel ?", o: ["Je commence un nouveau cycle", "Je me sens bloqué(e), quelque chose doit changer", "J'ai une décision importante à prendre", "Je cherche de la clarté, mieux me connaître"] },
        { t: "Avec quelle phrase t'identifies-tu le plus ?", o: ["« J'ai le sentiment qu'il y a quelque chose de plus pour moi que je n'ai pas encore trouvé »", "« Je répète des schémas dont j'ignore l'origine »", "« Les gens ne me connaissent pas vraiment »", "« Je suis au bon endroit, je veux le confirmer »"] },
        { t: "Quand tu prends des décisions importantes, qu'est-ce qui pèse le plus ?", o: ["Mon intuition — mon corps me parle", "La logique — j'analyse tout", "Ce que je ressens pour les autres", "Ça dépend du jour (et ça me déroute)"] },
        { t: "Que sais-tu de l'astrologie ?", o: ["Rien, ce serait ma première carte", "Je connais mon signe", "Je connais mon Soleil, ma Lune et mon Ascendant", "Pas mal — je veux une lecture sérieuse"] }
      ],
      signos: [
        ["Capricorne", "tu construis avec patience et tu es plus sensible que tu ne le montres"],
        ["Verseau", "esprit libre : tu vois ce que les autres ne voient pas encore"],
        ["Poissons", "intuition profonde — tu sens la marée avant tout le monde"],
        ["Bélier", "feu qui commence : là où les autres hésitent, tu as déjà commencé"],
        ["Taureau", "présence et constance : tu construis des choses qui durent"],
        ["Gémeaux", "curiosité infinie — ton esprit ne s'ennuie jamais"],
        ["Cancer", "mémoire émotionnelle profonde : tu prends soin comme personne"],
        ["Lion", "un cœur qui rayonne : tu es né(e) pour être vu(e)"],
        ["Vierge", "œil précis : tu améliores tout ce que tu touches"],
        ["Balance", "tu cherches l'harmonie et le juste équilibre des choses"],
        ["Scorpion", "intensité transformatrice : rien à moitié"],
        ["Sagittaire", "une flèche vers l'horizon : tu as besoin de sens, pas de routine"]
      ],
      paises: { MX: "Mexique", US: "États-Unis", CO: "Colombie", GT: "Guatemala", AR: "Argentine", ES: "Espagne", PE: "Pérou", CL: "Chili", EC: "Équateur", VE: "Venezuela", BO: "Bolivie", HN: "Honduras", SV: "Salvador", NI: "Nicaragua", CR: "Costa Rica", PA: "Panama", DO: "République dominicaine", PY: "Paraguay", UY: "Uruguay", PR: "Porto Rico", OTRO: "Autre pays" }
    },
    de: {
      qNum: function (n, total) { return "Dein Moment · Frage " + n + " von " + total; },
      nacTitulo: "Die Daten deines Horoskops",
      nacIntro: "Dein Geburtshoroskop wird mit dem EXAKTEN Himmel des Moments berechnet, in dem du geboren wurdest:",
      fecha: "Geburtsdatum",
      hora: "Geburtszeit",
      sinHora: "Ich kenne meine genaue Zeit nicht (dein Horoskop wird trotzdem berechnet)",
      pais: "Land, in dem du geboren wurdest",
      ciudad: "Stadt, in der du geboren wurdest",
      ciudadPh: "z. B. Guadalajara",
      calcular: "Mein Horoskop berechnen",
      errNac: "Gib dein Geburtsdatum und deinen Geburtsort ein.",
      emailTitulo: "Dein Horoskop wird berechnet",
      emailIntro: function (f, ciudad) {
        return "Planetenpositionen vom " + f.split("-").reverse().join(".") + " über " + ciudad + ". Für wen ist dieses Horoskop?";
      },
      nombrePh: "Dein Name",
      emailPh: "du@email.com",
      ver: "Mein kostenloses Ergebnis ansehen",
      errEmail: "Gib eine gültige E-Mail-Adresse ein.",
      emailNota: "Du erhältst dein Ergebnis und astrologische Inhalte. Kein Spam, du kannst dich jederzeit abmelden.",
      notaHora: "Ohne genaue Uhrzeit wird dein Horoskop im Sonnenmodus berechnet (ohne Aszendent und Häuser) — für alles andere genauso gültig.",
      tuSol: "Deine Sonne steht in",
      energia: function (n, d) { return n + "-Energie: " + d + "."; },
      solUno: "Aber deine Sonne ist nur <strong>1 der 12 Punkte</strong> deines Horoskops. Die anderen 11 haben wir bereits mit dem exakten Himmel deiner Geburt berechnet:",
      luna: "🔒 Dein <strong>Mond</strong> (deine echte Gefühlswelt)<br>",
      asc: "🔒 Dein <strong>Aszendent</strong> (wie die Welt dich sieht)<br>",
      venusMarte: "🔒 <strong>Venus und Mars</strong> (wie du liebst und begehrst)<br>",
      medioCielo: "🔒 Dein <strong>Medium Coeli</strong> (Berufung und Geld)<br>",
      aspectos: "🔒 Die <strong>Aspekte</strong> zwischen deinen Planeten (deine Muster)",
      cartaCompleta: "Dein vollständiges Geburtshoroskop",
      li1: "<strong>Berechnetes Geburtshoroskop</strong> mit Schweizer Ephemeriden — Präzision professioneller Software",
      li2: "Exakte Positionen deiner 10 Planeten, in Zeichen und Häusern",
      li3: "Deine integrierte große Drei: Sonne, Mond und Aszendent",
      li4: "Liebe, Karriere und Geld nach DEINEM Horoskop (nicht nach deinem Sternzeichen)",
      li5: function (e) { return "<strong>Besonderes Kapitel</strong> zu dem, was du gewählt hast: " + e; },
      li6: "PDF-Bericht mit 15+ Seiten, in unter 1 Stunde in deinem Postfach",
      precioNota: "Einmalzahlung. Kein Abo, keine wiederkehrenden Kosten.",
      comprar: "Ich möchte mein vollständiges Geburtshoroskop",
      errPago: "Wir konnten die Zahlung nicht starten. Bitte versuche es erneut.",
      garantia: "🛡️ 7-Tage-Garantie: Wenn es dir nichts bringt, erstatten wir dir 100 % zurück.",
      aviso: "Inhalt zur Unterhaltung und Selbsterkenntnis.",
      preparando: "Deine Zahlung wird vorbereitet…",
      enfoque: { a: "dein Liebesleben", c: "deine Karriere und dein Geld", p: "dein Lebenszweck", e: "deine Gefühlswelt" },
      preguntas: [
        { t: "Welchen Lebensbereich soll dein Horoskop zuerst beleuchten?", o: ["Die Liebe und meine Beziehungen", "Meine Karriere und das Geld", "Mein Lebenszweck", "Meine Energie und meine Gefühle"] },
        { t: "Wie würdest du deinen aktuellen Moment beschreiben?", o: ["Ich beginne einen neuen Zyklus", "Ich fühle mich festgefahren, etwas muss sich ändern", "Ich stehe vor einer wichtigen Entscheidung", "Ich suche Klarheit, um mich selbst besser kennenzulernen"] },
        { t: "Mit welchem Satz identifizierst du dich am meisten?", o: ["„Ich habe das Gefühl, dass es noch etwas mehr für mich gibt, das ich nicht gefunden habe“", "„Ich wiederhole Muster, von denen ich nicht weiß, woher sie kommen“", "„Die Leute kennen mich nicht wirklich“", "„Ich bin am richtigen Ort, ich möchte es bestätigen“"] },
        { t: "Wenn du wichtige Entscheidungen triffst, was wiegt am meisten?", o: ["Meine Intuition — mein Körper spricht zu mir", "Die Logik — ich analysiere alles", "Was ich für andere empfinde", "Das hängt vom Tag ab (und das verwirrt mich)"] },
        { t: "Wie viel weißt du über Astrologie?", o: ["Nichts, es wäre mein erstes Horoskop", "Ich kenne mein Sternzeichen", "Ich kenne meine Sonne, meinen Mond und meinen Aszendenten", "Ziemlich viel — ich möchte eine seriöse Deutung"] }
      ],
      signos: [
        ["Steinbock", "du baust geduldig auf und bist sensibler, als du zeigst"],
        ["Wassermann", "freier Geist: du siehst, was andere noch nicht sehen"],
        ["Fische", "tiefe Intuition — du spürst die Flut, bevor irgendjemand sonst sie spürt"],
        ["Widder", "Feuer, das anfängt: Wo andere zögern, hast du schon begonnen"],
        ["Stier", "Präsenz und Beständigkeit: du baust Dinge, die bleiben"],
        ["Zwillinge", "unendliche Neugier — dein Geist langweilt sich nie"],
        ["Krebs", "tiefes emotionales Gedächtnis: du sorgst dich wie niemand sonst"],
        ["Löwe", "ein Herz, das strahlt: du bist dazu geboren, gesehen zu werden"],
        ["Jungfrau", "präziser Blick: du verbesserst alles, was du anfasst"],
        ["Waage", "du suchst Harmonie und das rechte Maß der Dinge"],
        ["Skorpion", "verwandelnde Intensität: nichts halbherzig"],
        ["Schütze", "ein Pfeil zum Horizont: du brauchst Sinn, keine Routine"]
      ],
      paises: { MX: "Mexiko", US: "USA", CO: "Kolumbien", GT: "Guatemala", AR: "Argentinien", ES: "Spanien", PE: "Peru", CL: "Chile", EC: "Ecuador", VE: "Venezuela", BO: "Bolivien", HN: "Honduras", SV: "El Salvador", NI: "Nicaragua", CR: "Costa Rica", PA: "Panama", DO: "Dominikanische Republik", PY: "Paraguay", UY: "Uruguay", PR: "Puerto Rico", OTRO: "Anderes Land" }
    }
  };
  var LANG = String(CFG.locale || document.documentElement.lang || "es").slice(0, 2).toLowerCase();
  var T = I18N[LANG] || I18N.es;

  // Traducción de la pregunta i (solo si coincide en nº de opciones; si no, cae al español).
  function trPregunta(i) {
    var tq = T.preguntas && T.preguntas[i];
    var q = QUIZ.preguntas[i];
    return tq && tq.t && tq.o && tq.o.length === q.opciones.length ? tq : null;
  }
  function nombreSigno(s) {
    var i = QUIZ.signos.indexOf(s);
    return T.signos && i > -1 ? T.signos[i][0] : s.n;
  }
  function descSigno(s) {
    var i = QUIZ.signos.indexOf(s);
    return T.signos && i > -1 ? T.signos[i][1] : s.d;
  }
  function nombrePais(p) {
    return T.paises && T.paises[p.cc] ? T.paises[p.cc] : p.n;
  }

  function track(nombre, params, metaEvent) {
    try {
      if (window.gtag) gtag("event", nombre, params || {});
      if (window.fbq) {
        if (metaEvent) fbq("track", metaEvent, params || {});
        else fbq("trackCustom", nombre, params || {});
      }
    } catch (e) {}
  }

  track("quiz_start", {});
  render();

  function progreso(paso) {
    barra.style.width = Math.round(paso * 100 / TOTAL_PASOS) + "%";
  }

  function render() {
    progreso(idx);
    if (idx >= QUIZ.preguntas.length) return pasoNacimiento();

    var q = QUIZ.preguntas[idx];
    var tq = trPregunta(idx);
    var html =
      '<div class="paso">' +
      '<div class="q-num">' + T.qNum(idx + 1, QUIZ.preguntas.length) + "</div>" +
      '<div class="q-texto">' + (tq ? tq.t : q.texto) + "</div>" + '<div class="opciones">';
    q.opciones.forEach(function (op, i) {
      html += '<button class="opcion" data-i="' + i + '">' + (tq ? tq.o[i] : op.t) + "</button>";
    });
    html += "</div></div>";
    cont.innerHTML = html;

    Array.prototype.forEach.call(cont.querySelectorAll(".opcion"), function (b) {
      b.onclick = function () {
        var op = q.opciones[parseInt(b.getAttribute("data-i"), 10)];
        if (q.codigo && op.c) codigo[q.id] = op.c;
        idx++;
        track("quiz_q" + idx, {});
        render();
      };
    });
  }

  function pasoNacimiento() {
    progreso(QUIZ.preguntas.length);
    var opcionesPais = QUIZ.paises.map(function (p) {
      return '<option value="' + p.cc + '">' + nombrePais(p) + "</option>";
    }).join("");
    cont.innerHTML =
      '<div class="panel" style="text-align:left">' +
      '<h2 style="text-align:center">' + T.nacTitulo + '</h2>' +
      '<p style="text-align:center">' + T.nacIntro + '</p>' +
      '<label style="font-size:13px;font-weight:600">' + T.fecha + '</label>' +
      '<input type="date" id="rf-fecha" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 14px;background:var(--crema)">' +
      '<label style="font-size:13px;font-weight:600">' + T.hora + '</label>' +
      '<input type="time" id="rf-hora" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 6px;background:var(--crema)">' +
      '<label style="font-size:13px;display:block;margin-bottom:14px"><input type="checkbox" id="rf-sinhora"> ' + T.sinHora + '</label>' +
      '<label style="font-size:13px;font-weight:600">' + T.pais + '</label>' +
      '<select id="rf-pais" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 14px;background:var(--crema)">' + opcionesPais + "</select>" +
      '<label style="font-size:13px;font-weight:600">' + T.ciudad + '</label>' +
      '<input type="text" id="rf-ciudad" placeholder="' + T.ciudadPh + '" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 16px;background:var(--crema)">' +
      '<button class="btn btn-block" id="rf-calc">' + T.calcular + '</button>' +
      '<div class="error-msg" id="rf-errn">' + T.errNac + '</div>' +
      "</div>";

    document.getElementById("rf-sinhora").onchange = function () {
      document.getElementById("rf-hora").disabled = this.checked;
    };
    document.getElementById("rf-calc").onclick = function () {
      var fecha = document.getElementById("rf-fecha").value;
      var sinHora = document.getElementById("rf-sinhora").checked;
      var hora = sinHora ? null : document.getElementById("rf-hora").value;
      var ciudad = document.getElementById("rf-ciudad").value.trim();
      var cc = document.getElementById("rf-pais").value;
      if (!fecha || !ciudad || (!sinHora && !hora)) {
        document.getElementById("rf-errn").style.display = "block";
        return;
      }
      nac = { fecha: fecha, hora: hora, ciudad: ciudad, cc: cc };
      track("birth_data", {});
      idx = QUIZ.preguntas.length + 1;
      pasoEmail();
    };
  }

  function signoSolar(fecha) {
    var m = parseInt(fecha.slice(5, 7), 10), d = parseInt(fecha.slice(8, 10), 10);
    for (var i = 0; i < QUIZ.signos.length; i++) {
      var s = QUIZ.signos[i];
      if (m < s.hasta[0] || (m === s.hasta[0] && d <= s.hasta[1])) return s;
    }
    return QUIZ.signos[0]; // 22-31 dic → Capricornio
  }

  function pasoEmail() {
    progreso(QUIZ.preguntas.length + 1);
    cont.innerHTML =
      '<div class="panel"><div style="font-size:40px;margin-bottom:10px">✨</div>' +
      "<h2>" + T.emailTitulo + "</h2>" +
      "<p>" + T.emailIntro(nac.fecha, nac.ciudad) + "</p>" +
      '<input type="text" id="rf-nombre" placeholder="' + T.nombrePh + '" autocomplete="given-name" style="width:100%;padding:15px 18px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin-bottom:12px;background:var(--crema)">' +
      '<input type="email" id="rf-email" placeholder="' + T.emailPh + '" autocomplete="email">' +
      '<button class="btn btn-block" id="rf-ver">' + T.ver + '</button>' +
      '<div class="error-msg" id="rf-err">' + T.errEmail + '</div>' +
      '<p style="font-size:12px;margin-top:14px">' + T.emailNota + '</p></div>';

    document.getElementById("rf-ver").onclick = function () {
      var email = document.getElementById("rf-email").value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        document.getElementById("rf-err").style.display = "block";
        return;
      }
      sessionStorage.setItem("rf_email", email);
      sessionStorage.setItem("rf_nombre", (document.getElementById("rf-nombre").value || "").trim());
      track("email_captured", {}, "Lead");
      try {
        var fd = new FormData();
        fd.append("form_type", "customer");
        fd.append("utf8", "✓");
        fd.append("contact[email]", email);
        fd.append("contact[tags]", "carta-natal,enfoque-" + codigo.enfoque);
        fetch("/contact", { method: "POST", body: fd }).catch(function () {});
      } catch (e) {}
      resultado();
    };
  }

  function slug(txt) {
    return txt.toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
  }

  function resultado() {
    barra.style.width = "100%";
    track("quiz_complete", {});
    var s = signoSolar(nac.fecha);
    var precio = CFG.precioTexto || "$12.99 USD";
    var notaHora = nac.hora ? "" :
      '<p style="font-size:12.5px;color:var(--tinta-suave)">' + T.notaHora + '</p>';

    cont.innerHTML =
      '<div class="panel">' +
      '<p style="font-size:13px;letter-spacing:.08em;text-transform:uppercase;font-weight:600;color:var(--terracota-oscuro);margin-bottom:4px">' + T.tuSol + '</p>' +
      '<div class="arquetipo-chip">' + s.g + " " + nombreSigno(s) + "</div>" +
      "<p>" + T.energia(nombreSigno(s), descSigno(s)) + "</p>" +
      '<p style="font-size:14px">' + T.solUno + '</p>' +
      '<div style="text-align:left;background:var(--crema);border:1px solid var(--linea);border-radius:12px;padding:14px 18px;margin:12px 0;font-size:14.5px">' +
      T.luna +
      (nac.hora ? T.asc : "") +
      T.venusMarte +
      T.medioCielo +
      T.aspectos + "</div>" +
      "<hr style='border:none;border-top:1px solid var(--linea);margin:20px 0'>" +
      "<h2>" + T.cartaCompleta + "</h2>" +
      '<ul class="lista-plan">' +
      "<li>" + T.li1 + "</li>" +
      "<li>" + T.li2 + "</li>" +
      "<li>" + T.li3 + "</li>" +
      "<li>" + T.li4 + "</li>" +
      "<li>" + T.li5(nombreEnfoque()) + "</li>" +
      "<li>" + T.li6 + "</li></ul>" +
      '<div class="precio">' + precio + "</div>" +
      '<div class="precio-nota">' + T.precioNota + '</div>' +
      '<button class="btn btn-block" id="rf-comprar">' + T.comprar + '</button>' +
      '<div class="error-msg" id="rf-err2">' + T.errPago + '</div>' +
      notaHora +
      '<p class="garantia">' + T.garantia + '</p>' +
      '<p class="garantia" style="margin-top:6px">' + T.aviso + '</p></div>';

    document.getElementById("rf-comprar").onclick = comprar;
  }

  function nombreEnfoque() {
    return T.enfoque[codigo.enfoque];
  }

  function comprar() {
    var btn = document.getElementById("rf-comprar");
    btn.disabled = true;
    btn.textContent = T.preparando;
    track("begin_checkout", {}, "InitiateCheckout");

    if (CFG.stripeUrl) {
      // V2_{enfoque}{momento}{nivel}_{AAAAMMDD}_{HHMM|9999}_{ciudad-slug}_{CC}[_{nombre-slug}]
      var partes = ["V2",
        codigo.enfoque + codigo.momento + codigo.nivel,
        nac.fecha.replace(/-/g, ""),
        nac.hora ? nac.hora.replace(":", "") : "9999",
        slug(nac.ciudad) || "sin-ciudad",
        nac.cc
      ];
      var nombre = slug(sessionStorage.getItem("rf_nombre") || "").slice(0, 30);
      if (nombre) partes.push(nombre);
      var ref = partes.join("_").slice(0, 190);
      var email = sessionStorage.getItem("rf_email") || "";
      var sep = CFG.stripeUrl.indexOf("?") === -1 ? "?" : "&";
      window.location.href = CFG.stripeUrl + sep +
        "client_reference_id=" + encodeURIComponent(ref) +
        (email ? "&prefilled_email=" + encodeURIComponent(email) : "");
      return;
    }

    // Fallback: checkout Shopify (producto debe estar ACTIVE)
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{
          id: CFG.variantId,
          quantity: 1,
          properties: {
            "_perfil": codigo.enfoque + codigo.momento + codigo.nivel,
            "_nacimiento": nac.fecha + " " + (nac.hora || "sin-hora"),
            "_lugar": nac.ciudad + ", " + nac.cc,
            "_quiz_version": String(QUIZ.version)
          }
        }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart " + res.status);
        window.location.href = "/checkout";
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = T.comprar;
        document.getElementById("rf-err2").style.display = "block";
      });
  }
})();
